import React from "react";
import Slider from "react-slick/lib/slider";
import { NextArrow, PrevArrow } from "components/Common/Arrows";
import ProductCard from "components/ProductCard";
import { Link } from "react-router-dom";

const FeatureProductSlider = ({ product }) => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    // slidesToShow: Math.min(product.items.length, 6),
    slidesToShow: 6,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 3,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
    ],
  };

  return (
    <>
      <div className="sellerpage-title" key={product.id}>
        <h1>{product.name}</h1>
        <Link to={`/departments/${product.url}`}>{product.url_label}</Link>
      </div>
      <Slider {...settings}>
        {product.items.map((product, index) => {
          return (
            <>
              <ProductCard product={product} key={product.id} />
            </>
          );
        })}
      </Slider>
    </>
  );
};
export default FeatureProductSlider;
